import { Service } from '../Service';
import { SearchTerm } from '../../model/terms/SearchTerm';

export interface ISearchTermParams extends IParams {
  projectId: string;
  searchTermListId: string;
}

export class SearchTermService extends Service<any> {
  private notificationService;

  constructor(resource: any, rootScope: IRootScope, configService, resourceWrapperService, notificationService) {
    super({resource, rootScope, resourceWrapperService});

    const searchTermListResource = resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/searchtermlist/:searchTermListId/terms/:id`,
      {'id': '@id', 'projectId': '@projectId', 'searchTermListId': '@searchTermListId'},
      {
        'update': {method: "PUT"},
        'query': {method: "GET", isArray: false}
      }
    );

    this.itemResource = resourceWrapperService.WrapActions(searchTermListResource);
    this.notificationService = notificationService;

    // SearchTermComplete / SearchTermUpdate are handled in React
    // (src/hooks/useSearchTerms -> WebSocketBridge), including the completion toast.
  }

  public async FindAll(params: ISearchTermParams) {
    return this.itemResource.query({
      projectId: params.projectId,
      searchTermListId: params.searchTermListId
    }).$promise as any;
  }

  public Delete(searchTerm, callback?: Function, errorCallback?: Function) {
    const searchTermResource = new this.itemResource(angular.copy(searchTerm));
    searchTermResource.$delete((response, deleteResponseHeaders) => callback?.call(this, response), () => {
      this.notificationService.addError({
        title: "Error deleting search term",
        description: "That's embarrassing, please try again later",
        timeout: 5000
      });
      errorCallback?.call(this);
    });
  };
}

frontendApp.factory("SearchTermService", ['$resource', '$rootScope', 'ConfigService', 'ResourceWrapperService', 'NotificationService', function(resource, rootScope, configService, resourceWrapperService, notificationService) {
  return new SearchTermService(resource, rootScope, configService, resourceWrapperService, notificationService);
}]);
